import { VirtualTournament } from '@sportOfferFederation/competitions/types';

export function findVirtualTournamentByTournamentId(
    virtualTournaments: VirtualTournament[],
    id: number,
): VirtualTournament | undefined {
    return virtualTournaments.find((tournament) => tournament.tournamentId === id);
}
